import { Component, Input, OnInit } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

import { AuthService } from '../../services/auth.service';
import { RouterUrls } from '../router-urls';
import * as Projects from '../../shared/projects.model';
import { ProjectsService } from 'src/app/services/projects.service';
import { LanguageService } from 'src/app/services/language.service';
import { Constants } from '../../app.constants';
import { ProjectsConstants } from '../../browse-projects-module/projects.constants';

@Component({
  selector: 'app-project-card',
  templateUrl: './project-card.component.html',
  styleUrls: ['./project-card.component.scss']
})
export class ProjectCardComponent implements OnInit {
  readonly ProjectsConstants = ProjectsConstants;

  @Input() id: number;
  @Input() name: string;
  @Input() slug: string;
  @Input() northStar: string;
  @Input() northStar2: string;
  @Input() northStar3: string;
  @Input() continent: string;
  @Input() country: string;
  @Input() organization: string;
  @Input() imgUrl: string;
  @Input() isSupported: boolean;
  @Input() vettedBy: string;
  @Input() ownMoneyProjects: Projects.PartialProject[];
  backgroundStyle: any;

  isCardHovered = false;
  isTablet: boolean;
  isLogged = false;
  isLoggedSubs: Subscription;
  _ownMoneyProjects: Projects.PartialProject[];
  projectUrl: string;

  constructor(private breakpointObserver: BreakpointObserver,
              private projectsService: ProjectsService,
              private languageService: LanguageService,
              private authService: AuthService) {
    this.isLoggedSubs = this.authService.isUserLogged.subscribe(value => this.isLogged = value);
  }

  ngOnInit(): void {
    this.updateBackgroundStyle();
    this.projectUrl = `${ Constants.APP_URL + this.languageService.getLanguage() }/${ RouterUrls.BrowseProjects }/${ this.slug }`;
    this.breakpointObserver
      .observe(['(max-width: 991px)'])
      .subscribe((state: BreakpointState) => {
        this.isTablet = state.matches;
      });
    if (this.isLogged && !this.ownMoneyProjects) {
      this.projectsService.getProjectsOwnMoney().subscribe(projects => {
        if (projects) {
          this._ownMoneyProjects = projects;
        }
      });
    }
  }

  isOwnMoney(projectId: number): boolean {
    let result = null;
    if (this._ownMoneyProjects) {
      result = this._ownMoneyProjects.find(project => project.id === projectId);
    }
    return result && result !== -1;
  }

  updateBackgroundStyle() {
    this.backgroundStyle = {
      backgroundImage:
        `linear-gradient(180deg, rgba(15,70,84,0) 0%, rgba(25,81,95,0) 33.85%, rgb(12,51,61) 100%), url(${ this.imgUrl })`
    };
  }
}
